/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2020, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 *          Nguyễn Anh Khoa <khoaakt@gmail.com>
            Julien Gomes Dias <abld@abld.info>
            Filip Š <projects@filips.si>
            Matheus Felipe <matheusfelipeog@gmail.com>
 * @licence Simplified BSD License
 */


export const de_DE = {
  LBL_PANEL_ALL: 'Panel hinzufügen',
  LBL_PANEL_REMOVE: 'Panel entfernen',
  LBL_PANELITEM_ADD: 'Panelelemente hinzufügen',
  LBL_PANELITEM_REMOVE: 'Panelelemente entfernen',
  LBL_PANEL_POSITION: 'Panel-Position',
  LBL_SAVE_AND_LOG_OUT: 'Session speichern & Abmelden',
  LBL_LOG_OUT: 'Abmelden'
};

export const en_EN = {
  LBL_PANEL_ALL: 'Add panel',
  LBL_PANEL_REMOVE: 'Remove panel',
  LBL_PANELITEM_ADD: 'Add panelitem',
  LBL_PANELITEM_REMOVE: 'Remove panelitem',
  LBL_PANEL_POSITION: 'Panel Position',
  LBL_SAVE_AND_LOG_OUT: 'Save Session & Log Out',
  LBL_LOG_OUT: 'Log Out',
  LBL_LAUNCHING: 'Launching \'{0}\''
};

export const sv_SE = {
  LBL_PANEL_ALL: 'Lägg till panel',
  LBL_PANEL_REMOVE: 'Ta bort panel',
  LBL_PANELITEM_ADD: 'Lägg till panelobjekt',
  LBL_PANELITEM_REMOVE: 'Ta bort panelobjekt',
  LBL_PANEL_POSITION: 'Panelposition',
  LBL_SAVE_AND_LOG_OUT: 'Spara session och logga ut',
  LBL_LOG_OUT: 'logga ut',
  LBL_LAUNCHING: 'Startar \'{0}\''
};

export const fr_FR = {
  LBL_PANEL_ALL: 'Ajouter le panneau',
  LBL_PANEL_REMOVE: 'Supprimer le panneau',
  LBL_PANELITEM_ADD: 'Ajouter des éléments au panneau',
  LBL_PANELITEM_REMOVE: 'Supprimer des éléments au panneau',
  LBL_PANEL_POSITION: 'La position du panneau',
  LBL_SAVE_AND_LOG_OUT: 'Sauvegarder la session et se déconnecter',
  LBL_LOG_OUT: 'Se déconnecter'
};

export const nb_NO = {
  LBL_PANEL_ALL: 'Legg til panel',
  LBL_PANEL_REMOVE: 'Fjern panel',
  LBL_PANELITEM_ADD: 'Legg til panelobjekt',
  LBL_PANELITEM_REMOVE: 'Fjern panelobjekt',
  LBL_PANEL_POSITION: 'Panelposisjon',
  LBL_SAVE_AND_LOG_OUT: 'Lagre Sessjon & Logg Ut',
  LBL_LOG_OUT: 'Logg Ut',
  LBL_LAUNCHING: 'Laster \'{0}\''
};

export const sl_SI = {
  LBL_PANEL_ALL: 'Dodaj ploščo',
  LBL_PANEL_REMOVE: 'Odstrani ploščo',
  LBL_PANELITEM_ADD: 'Dodaj element plošče',
  LBL_PANELITEM_REMOVE: 'Odstrani element plošče',
  LBL_PANEL_POSITION: 'Položaj plošče',
  LBL_SAVE_AND_LOG_OUT: 'Shranitev seje & Odjava',
  LBL_LOG_OUT: 'Odjava'
};

export const vi_VN = {
  LBL_PANEL_ALL: 'Thêm panel',
  LBL_PANEL_REMOVE: 'Xóa panel',
  LBL_PANELITEM_ADD: 'Thêm mục panel',
  LBL_PANELITEM_REMOVE: 'Xóa mục panel',
  LBL_PANEL_POSITION: 'Vị trí panel',
  LBL_SAVE_AND_LOG_OUT: 'Lưu phiên & Đăng xuất',
  LBL_LOG_OUT: 'Đăng xuất',
  LBL_LAUNCHING: 'Đang khởi động \'{0}\''
};

export const pt_BR = {
  LBL_PANEL_ALL: 'Adicionar painel',
  LBL_PANEL_REMOVE: 'Remover painel',
  LBL_PANELITEM_ADD: 'Adicionar item ao painel',
  LBL_PANELITEM_REMOVE: 'Remover item do painel',
  LBL_PANEL_POSITION: 'Posição do painel',
  LBL_SAVE_AND_LOG_OUT: 'Salvar sessão & Sair',
  LBL_LOG_OUT: 'Sair',
  LBL_LAUNCHING: 'Lançamento \'{0}\''
};

export const tr_TR = {
  LBL_PANEL_ALL: 'Panel ekle',
  LBL_PANEL_REMOVE: 'Paneli sil',
  LBL_PANELITEM_ADD: 'Panel nesnesi ekle',
  LBL_PANELITEM_REMOVE: 'Panel nesnesini sil',
  LBL_PANEL_POSITION: 'Panel Konumu',
  LBL_SAVE_AND_LOG_OUT: 'Oturumu Kaydet & Çıkış Yap',
  LBL_LOG_OUT: 'Çıkış Yap',
  LBL_LAUNCHING: 'Başlatılıyor \'{0}\''
};
